/* eslint-disable no-warning-comments */

import * as React from 'react'
import urljoin from 'url-join'

import {DEFAULT_LOCALE, LOCALES, SITE_NAME, SITE_URL} from '@/common/config'
import {getUnlocalizedFullSlug, sanitizeFullSlug, urljoinWithTrailing} from '@/common/utils'

const HeadComponent = (story) => {
  const getTitle = (title) => title || story.title || story.name
  const getDescription = (description) => description || story.description
  const getThumbnail = (image) => {
    if (image && image.filename) {
      return `${image.filename}/m/1200x627/smart`
    } else if (story.cover && story.cover.filename) {
      return `${story.cover.filename}/m/1200x627/smart`
    } else if (story.og_image && story.og_image.filename) {
      return `${story.og_image.filename}/m/1200x627/smart`
    } else {
      return urljoin(SITE_URL, `/og-image.png`)
    }
  }

  const fullSlug = sanitizeFullSlug(story.full_slug)
  const unlocalizedFullSlug = getUnlocalizedFullSlug(fullSlug)

  const canonical = urljoinWithTrailing(SITE_URL, fullSlug)
  const lang = story.lang === 'default' ? DEFAULT_LOCALE : story.lang

  return (
    <>
      {/* FAVICON - DO NOT TOUCH - Populate by prebuild.js */}
      <link rel="icon" type="image/x-icon" href="/favicons/favicon.ico"/>
<link rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png"/>
<link rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png"/>
<link rel="icon" type="image/png" sizes="48x48" href="/favicons/favicon-48x48.png"/>
<link rel="manifest" href="/favicons/manifest.webmanifest"/>
<meta name="mobile-web-app-capable" content="yes"/>
<meta name="theme-color" content="#fff"/>
<meta name="application-name"/>
<link rel="apple-touch-icon" sizes="57x57" href="/favicons/apple-touch-icon-57x57.png"/>
<link rel="apple-touch-icon" sizes="60x60" href="/favicons/apple-touch-icon-60x60.png"/>
<link rel="apple-touch-icon" sizes="72x72" href="/favicons/apple-touch-icon-72x72.png"/>
<link rel="apple-touch-icon" sizes="76x76" href="/favicons/apple-touch-icon-76x76.png"/>
<link rel="apple-touch-icon" sizes="114x114" href="/favicons/apple-touch-icon-114x114.png"/>
<link rel="apple-touch-icon" sizes="120x120" href="/favicons/apple-touch-icon-120x120.png"/>
<link rel="apple-touch-icon" sizes="144x144" href="/favicons/apple-touch-icon-144x144.png"/>
<link rel="apple-touch-icon" sizes="152x152" href="/favicons/apple-touch-icon-152x152.png"/>
<link rel="apple-touch-icon" sizes="167x167" href="/favicons/apple-touch-icon-167x167.png"/>
<link rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon-180x180.png"/>
<link rel="apple-touch-icon" sizes="1024x1024" href="/favicons/apple-touch-icon-1024x1024.png"/>
<meta name="apple-mobile-web-app-capable" content="yes"/>
<meta name="apple-mobile-web-app-status-bar-style" content="black-translucent"/>
<meta name="apple-mobile-web-app-title"/>
<link rel="apple-touch-startup-image" media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-640x1136.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-1136x640.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-750x1334.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-1334x750.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1125x2436.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2436x1125.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1170x2532.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2532x1170.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1179x2556.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2556x1179.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-828x1792.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-1792x828.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1242x2688.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2688x1242.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1242x2208.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2208x1242.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1284x2778.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2778x1284.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1290x2796.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2796x1290.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 744px) and (device-height: 1133px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1488x2266.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 744px) and (device-height: 1133px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2266x1488.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1536x2048.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2048x1536.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1620x2160.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2160x1620.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 820px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1640x2160.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 820px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2160x1640.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1668x2388.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2388x1668.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-1668x2224.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2224x1668.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/favicons/apple-touch-startup-image-2048x2732.png"/>
<link rel="apple-touch-startup-image" media="(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/favicons/apple-touch-startup-image-2732x2048.png"/>
<meta name="msapplication-TileColor" content="#fff"/>
<meta name="msapplication-TileImage" content="/favicons/mstile-144x144.png"/>
<meta name="msapplication-config" content="/favicons/browserconfig.xml"/>
<link rel="yandex-tableau-widget" href="/favicons/yandex-browser-manifest.json"/>
      {/* FONTS */}
      {['MillikRegular', 'Satoshi-Bold', 'Satoshi-Italic', 'Satoshi-Medium', 'Satoshi-Regular'].map(
        (font) => (
          <link
            key={font}
            rel='preload'
            href={`/fonts/${font}.woff2`}
            as='font'
            type='font/woff2'
            crossgitOrigin='anonymous'
          />
        )
      )}
      {/* ALTERNATES */}
      <link
        rel='alternate'
        hrefLang={DEFAULT_LOCALE}
        href={urljoinWithTrailing(SITE_URL, unlocalizedFullSlug)}
      />
      {LOCALES.map((locale) => (
        <link
          key={locale}
          rel='alternate'
          hrefLang={locale}
          href={urljoinWithTrailing(SITE_URL, locale, unlocalizedFullSlug)}
        />
      ))}
      {/* SEO */}
      <link rel='canonical' href={canonical} />
      <title>{getTitle()}</title>
      <meta name='description' content={getDescription()} />
      {/* OG  */}
      <meta property='og:locale' content={lang} />
      <meta property='og:url' content={canonical} />
      <meta property='og:site_name' content={SITE_NAME} />
      <meta property='og:title' content={getTitle(story.og_title)} />
      <meta property='og:description' content={getDescription(story.og_description)} />
      <meta property='og:image' content={getThumbnail(story.og_image)} />
      <meta property='og:image:secure_url' content={getThumbnail(story.og_image)} />
      <meta property='og:type' content='website' />
      {/* TWITTER */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={getTitle(story.twitter_title)} />
      <meta name='twitter:description' content={getDescription(story.twitter_description)} />
      <meta name='twitter:twitter_image' content={getThumbnail(story.twitter_image)} />
      <meta name='twitter:image:alt' content={getTitle(story.twitter_title)} />
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: `{
            "@context": "http://schema.org",
            "@type": "WebSite",
              "name": "${SITE_NAME}",
              "url": "${canonical}"
          }`,
        }}
      />
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: `{
            "@context": "http://schema.org",
            "@type": "WebPage",
              "name": "${getTitle()}",
              "description": "${getDescription()}"
          }`,
        }}
      />

      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: `{
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "${SITE_NAME}",
            "image": "${getThumbnail(story.og_image)}",
            "url": "${SITE_URL}",
            "@id": "${SITE_URL}",
            "vatID": "FR24844516245",
            "identifier": {
              "@type": "PropertyValue",
              "name": "SIREN",
              "value": "844516245"
            },
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "64-66 Rue des Archives",
              "addressLocality": "Paris",
              "postalCode": "75003",
              "addressCountry": "FR"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "48.8618049",
              "longitude": "2.3591222"
            },
            "sameAs": [
              "https://www.linkedin.com/company/witik/",
            ],
          }`,
        }}
      />

      {Array.isArray(story.breadcrumb) && story.breadcrumb.length > 0 && (
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
            "itemListElement": [${story.breadcrumb
              .map(
                (item, index) => `
                {
                  "@type": "ListItem",
                  "position": ${index + 1},
                  "name": "${item.title || item.name}",
                  "item": "${urljoinWithTrailing(SITE_URL, item.full_slug)}"
                }
              `
              )
              .join(',')},
              {
                "@type": "ListItem",
                "position": ${story.breadcrumb.length + 1},
                "name": "${getTitle()}",
                "item": "${canonical}"
              }]
        }`,
          }}
        />
      )}
      {story.author && (
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `{
          "@context": "https://schema.org",
          "@type": "Person",
          "name": "${story.author?.name}",
          "jobTitle":"${story.author?.content?.job}",
          "givenName":"${story.author?.name}",
          "sameAs" :"${story.author?.content?.linkedin?.url}",
           "url":"${
             story.author?.content?.authorPage?.url || story.author?.content?.authorPage?.cached_url
           }"
        }`,
          }}
        />
      )}

      {story.layout.name === 'Blog Post' && story.author && (
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "https://schema.org",
              "@type": "NewsArticle",
              "headline": "${story.name || story.title}",
              "image": [
                "${story.cover.filename}"
              ],
              "datePublished": "${story.date}",
              "author": [{
                "@type": "Person",
                "name": "${story.author?.name}",
                "jobTitle":"${story.author?.content?.job}",
                "givenName":"${story.author?.name}",
                "sameAs" :"${story.author?.content?.linkedin?.url}",
                "url":"${
                  story.author?.content?.authorPage?.url ||
                  story.author?.content?.authorPage?.cached_url
                }"
              }]
            }`,
          }}
        />
      )}

      {story.category.name === 'Événements' && (
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "https://schema.org",
              "@type": "Event",
              "name": "${story.name || story.title}",
              "startDate":  "${story.date}",
              "endDate": "${story.date}",
              "image": [
                "${story.cover.filename}"
              ],
              "description":"${story.description}",
              "location": { 
                "@type": "VirtualLocation", 
                "url": "${story.full_slug}" 
              },
              "performer": [
                {"@type": "Person", "name": "${story.author?.name}"},
              ] 
            }`,
          }}
        />
      )}
    </>
  )
}

export default HeadComponent
